module.exports = __webpack_public_path__ + "static/media/cloud-download.1c8e00a3.svg";